// extracted by mini-css-extract-plugin
export default {"displayPage":"displayPage--BNwPk"};